import React from "react";
import { Button, Typography } from "@mui/material";
import { IoArrowBackOutline, IoChevronForwardSharp } from "react-icons/io5";
import Header from "../../Header";
import MenuBar from "../../MenuBar";
import Footer from "../../Footer";
import { useNavigate } from "react-router";
import { TbCircleFilled } from "react-icons/tb";
import { useState } from "react";
import RefundModal from "../../modals/refundModal";

const refundData = [
  {
    date: "30 June 2023",
    noOfItems: 150,
    totalAmount: 1500,
    refundAmount: 150,
    status: "In progress",
    action: "Approve",
  },
  {
    date: "10 June 2023",
    noOfItems: 150,
    totalAmount: 1500,
    refundAmount: 150,
    status: "Settled",
    action: "Approved",
  },
  {
    date: "15 June 2023",
    noOfItems: 150,
    totalAmount: 1500,
    refundAmount: 150,
    status: "Settled",
    action: "Approved",
  },
  {
    date: "19 June 2023",
    noOfItems: 150,
    totalAmount: 1500,
    refundAmount: 150,
    status: "In progress",
    action: "Approve",
  },
  {
    date: "05 June 2023",
    noOfItems: 150,
    totalAmount: 1500,
    refundAmount: 150,
    status: "In progress",
    action: "Approve",
  },
];

export default function BatchRefundDetails() {
  const navigate = useNavigate();
  const [showRefundModal, setShowRefundModal] = useState(false);
  const handleShowRefundModal = () => {
    setShowRefundModal(true);
  };

  const handleCloseRefundModal = () => {
    setShowRefundModal(false);
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div
            className="card collapsed-card"
            style={{ paddingLeft: "20px", border: "none" }}
          >
            <div className="d-flex flex-row align-items-center">
              <IoArrowBackOutline
                style={{
                  height: "21.92px",
                  width: "23.91px",
                  cursor: "pointer",
                }}
                onClick={() => navigate("/transactions/batchRefund")}
              />
              <Typography
                variant="h4"
                sx={{
                  fontFamily: "Poppins",
                  fontWeight: 700,
                  fontSize: "28px",
                  height: "36px",
                  width: "200px",
                }}
              >
                Batch Refund
              </Typography>
            </div>
            <div className="row align-items-center pl-3 pt-2">
              <Typography
                style={{
                  fontSize: "14px",
                  fontWeight: 600,
                  color: "rgba(1, 1, 2, 0.92)",
                  height: "18px",
                  width: "143px",
                  fontFamily: "Poppins",
                }}
              >
                Order Management
              </Typography>
              <Typography
                className="pl-2"
                style={{
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: 400,
                  color: "rgba(1, 1, 2, 0.72)",
                  height: "18px",
                }}
              >
                <IoChevronForwardSharp className="mr-1" />
                Batch Refund
              </Typography>
              <Typography
                className="pl-2"
                style={{
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: 400,
                  color: "rgba(1, 1, 2, 0.72)",
                  height: "18px",
                }}
              >
                <IoChevronForwardSharp className="mr-1" />
                10 June 2023
              </Typography>
            </div>
            <div className="pl-2 pt-4 pr-2 row justify-content-between">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <Typography
                      style={{
                        fontSize: "12px",
                        fontWeight: 600,
                        height: "14px",
                        width: "100px",
                        color: "rgba(1, 1, 2, 0.6)",
                        fontFamily: "Poppins",
                      }}
                    >
                      Date Created
                    </Typography>
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 600,
                        fontFamily: "Poppins",
                        height: "20px",
                      }}
                    >
                      10 June 2023
                    </Typography>
                  </div>
                  <div className="col-md-4 mb-3">
                    <Typography
                      style={{
                        fontSize: "12px",
                        fontWeight: 600,
                        height: "14px",
                        width: "80px",
                        color: "rgba(1, 1, 2, 0.6)",
                        fontFamily: "Poppins",
                      }}
                    >
                      No of items
                    </Typography>
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 600,
                        fontFamily: "Poppins",
                        height: "20px",
                      }}
                    >
                      120
                    </Typography>
                  </div>
                  <div className="col-md-4 mb-3">
                    <Typography
                      style={{
                        fontSize: "12px",
                        fontWeight: 600,
                        height: "14px",
                        width: "80px",
                        color: "rgba(1, 1, 2, 0.6)",
                        fontFamily: "Poppins",
                      }}
                    >
                      Status
                    </Typography>
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 600,
                        fontFamily: "Poppins",
                        height: "20px",
                      }}
                    >
                      <TbCircleFilled
                        style={{
                          height: "12px",
                          width: "12px",
                          marginRight: "5px",
                          color: "#DE970D",
                        }}
                      />
                      In Progress
                    </Typography>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <Typography
                      style={{
                        fontSize: "12px",
                        fontWeight: 600,
                        height: "14px",
                        color: "rgba(1, 1, 2, 0.6)",
                        fontFamily: "Poppins",
                      }}
                    >
                      Total Amount
                    </Typography>
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 600,
                        fontFamily: "Poppins",
                        height: "20px",
                      }}
                    >
                      $1200
                    </Typography>
                  </div>
                  <div className="col-md-4 mb-3">
                    <Typography
                      style={{
                        fontSize: "12px",
                        fontWeight: 600,
                        height: "14px",
                        color: "rgba(1, 1, 2, 0.6)",
                        fontFamily: "Poppins",
                      }}
                    >
                      Total Refund Amount
                    </Typography>
                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 600,
                        fontFamily: "Poppins",
                        height: "20px",
                      }}
                    >
                      $100
                    </Typography>
                  </div>
                </div>
              </div>
              <div className="col-md-6 d-flex justify-content-end">
                <Button
                  variant="outlined"
                  style={{
                    borderColor: "rgba(36, 183, 170, 1)",
                    color: "rgba(36, 183, 170, 1)",
                    marginRight: "10px",
                    textTransform: "none",
                    fontSize: "16px",
                    width: "192px",
                    height: "42px",
                    fontWeight: 600,
                    borderRadius: "16px",
                    border: "2px solid",
                    fontFamily: "Poppins",
                  }}
                >
                  Download CSV
                </Button>
                <Button
                  onClick={() => handleShowRefundModal()}
                  variant="contained"
                  style={{
                    backgroundColor: "#24B7AA",
                    textTransform: "none",
                    width: "192px",
                    height: "42px",
                    fontWeight: 600,
                    fontSize: "16px",
                    borderRadius: "16px",
                    fontSize: "20px",
                    fontFamily: "Poppins",
                  }}
                >
                  Approve All
                </Button>
              </div>
            </div>

            {/* Table will be shown */}

            <RefundModal
              openModal={showRefundModal}
              onClose={handleCloseRefundModal}
            />

            <Typography> Table</Typography>
          </div>
        </section>
      </div>
    </>
  );
}
